export enum ContractsCargoTaxiAddRequestModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type ContractsCargoTaxiAddRequestBody = {
  allowChargeWhileApproaching: boolean;
  allowChargeWhileReturning: boolean;
  allowChargeDuringRide: boolean;
  discountLimit: number;
  validSince: Date;
  validTo: Date;
  disabled: boolean;
  model: ContractsCargoTaxiAddRequestModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  publishingAllowed: boolean;
  cargoCompanyId: string;
  taxiCorporationId: string;
  contactPassengerAfterMinutes: number;
  cancelByTaxiAllowed?: boolean;
  editByTaxiAllowed?: boolean;
};

type ContractsCargoTaxiAddRequest = {
  allowChargeWhileApproaching: boolean;
  allowChargeWhileReturning: boolean;
  allowChargeDuringRide: boolean;
  discountLimit: number;
  validSince: Date;
  validTo: Date;
  disabled: boolean;
  model: ContractsCargoTaxiAddRequestModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  publishingAllowed: boolean;
  cargoCompanyId: string;
  taxiCorporationId: string;
  contactPassengerAfterMinutes: number;
  cancelOrderByTaxiAllowed?: boolean;
  editOrderByTaxiAllowed?: boolean;
};

export default ContractsCargoTaxiAddRequest;
